import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { marquee } from '../../data/profile';
import './Marquee.css';

export default function Marquee() {
  const reduce = useReducedMotion();
  const items = [...marquee, ...marquee];

  return (
    <div className="marquee" aria-hidden>
      <motion.div
        className="marquee__track"
        animate={reduce ? {} : { x: ['0%', '-50%'] }}
        transition={{ duration: 36, repeat: Infinity, ease: 'linear' }}
      >
        {items.map((item, i) => (
          <span className="marquee__item" key={`${item}-${i}`}>
            <span className={i % 3 === 1 ? 'marquee__word marquee__word--em' : 'marquee__word'}>{item}</span>
            <span className="marquee__dot" />
          </span>
        ))}
      </motion.div>
    </div>
  );
}
